import axiosCustom from "../utils/axiosInstance";
import { NotificationResponseDto } from "../models/notification/NotificationResponseDto";

const API_BASE_URL = "/notifications";

export interface NotificationPage {
  content: NotificationResponseDto[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export interface NotificationFilterDto {
  group?: string;
  keyword?: string;
  isRead?: boolean;
  fromDate?: string;
  toDate?: string;
}

const cleanFilter = (filter?: NotificationFilterDto): NotificationFilterDto => {
  if (!filter) return {};
  return Object.fromEntries(
    Object.entries(filter).filter(([, value]) => value !== undefined && value !== null && value !== ""),
  ) as NotificationFilterDto;
};

export const getNotifications = async (page = 0, size = 10, filter?: NotificationFilterDto): Promise<NotificationPage> => {
  const res = await axiosCustom.get<NotificationPage>(API_BASE_URL, { params: { ...cleanFilter(filter), page, size } });
  return res.data;
};

export const getNotificationsForCounts = async (size = 100, filter?: NotificationFilterDto): Promise<NotificationResponseDto[]> => {
  const firstPage = await getNotifications(0, size, filter);
  if (firstPage.totalPages <= 1) return firstPage.content;

  const remainingPages = await Promise.all(
    Array.from({ length: firstPage.totalPages - 1 }, (_, index) => getNotifications(index + 1, size, filter)),
  );

  return [firstPage, ...remainingPages].flatMap((page) => page.content);
};

export const searchNotifications = async (
  keyword: string,
  page: number,
  size: number,
  filter: NotificationFilterDto = {},
): Promise<NotificationPage> => getNotifications(page, size, { ...filter, keyword: keyword || undefined });

export const getUnreadCount = async (): Promise<number> => {
  const res = await axiosCustom.get<{ count: number }>(`${API_BASE_URL}/unread-count`);
  return res.data.count;
};

export const markNotificationAsRead = async (id: string): Promise<void> => {
  await axiosCustom.patch(`${API_BASE_URL}/${id}/read`);
};

export const markAllNotificationsAsRead = async (): Promise<void> => {
  await axiosCustom.patch(`${API_BASE_URL}/read-all`);
};
